import { router } from "@inertiajs/react"
import type { ReactNode } from "react"
import { RouterProvider as AriaRouterProvider } from "react-aria-components"

interface RouterProviderProps {
  children: ReactNode
}

/**
 * Bridges React Aria's navigation to Inertia.js router.
 *
 * React Aria components use `href` props for navigation. This provider
 * intercepts those navigations and routes them through Inertia to avoid
 * full page reloads.
 *
 * @example
 * ```tsx
 * // In persistent-layout.tsx
 * <RouterProvider>
 *   {children}
 * </RouterProvider>
 * ```
 */
export function RouterProvider({ children }: RouterProviderProps) {
  return (
    <AriaRouterProvider navigate={(to, options) => router.visit(to, options)}>
      {children}
    </AriaRouterProvider>
  )
}
